import { Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { ChangingDirectionType, ChangingParameters, Restrictions } from "../types";
import { optionParametersSelectorManager } from "../utils/OptionParametersSelectorManager";
import { ToolsPanelButton } from "./ToolsPanelButton";
import { SelectorButtonContent } from "../views";
import {
    usePortfolioSelection,
} from "../../../shared/contexts/portfolio-context/components/PortfolioContextProvider";

export function OptionStrikeSelector({
    parameters
 }: {
    parameters: ChangingParameters;
}) {
    const {
        isAllPortfoliosSelected,
    } = usePortfolioSelection();
    const [restrictions, setRestrictions] = useState<Restrictions | null>(
        optionParametersSelectorManager.getStrikeRestrictions(parameters));
    
    const handleChange = async (direction: ChangingDirectionType): Promise<void> => {
        if (isAllPortfoliosSelected) {
            return;
        }

        await optionParametersSelectorManager.changeStrike(direction, parameters);
        setRestrictions(optionParametersSelectorManager.getStrikeRestrictions(parameters));
    }

    useEffect(() => {
        setRestrictions(optionParametersSelectorManager.getStrikeRestrictions(parameters));
    }, [parameters.selectedOrder]);

    const isButtonDisabled = (isRestricted: boolean | undefined) =>
        isAllPortfoliosSelected ||
        !optionParametersSelectorManager.isCommandApplicable(parameters) ||
        !(isRestricted ?? false);
    
    return (
        <Stack direction="row" spacing={0.5}>
            <ToolsPanelButton
                tooltipText="Change to the previous strike"
                disabled={isButtonDisabled(restrictions?.canChangeToPrevious)}
                onChanged={() => handleChange(ChangingDirectionType.Previous)}
            >
                <SelectorButtonContent content='S' direction={ChangingDirectionType.Previous} />
            </ToolsPanelButton>
            <ToolsPanelButton
                tooltipText="Change to the next strike"
                disabled={isButtonDisabled(restrictions?.canChangeToNext)}
                onChanged={() => handleChange(ChangingDirectionType.Next)}
            >
                <SelectorButtonContent content='S' direction={ChangingDirectionType.Next} />
            </ToolsPanelButton>
        </Stack>
    );
}
